import { Helmet } from "react-helmet";
import Footer from "../Footer/Footer";
import CommonHomeNavbar from "../Navbar/CommonHomeNavbar";
import "./StaticPage.css";
function Disclaimer() {
  return (
    <>
      <CommonHomeNavbar />

      <Helmet>
        {/* meta tags */}
        <title>
          Disclaimer | Masala of India Cusine, Northgate, Seattle - WA        </title>
        <meta
          name="description"
          content="Read the Disclaimer of the services provided by Masala of India Cusine, Northgate, Seattle - WA, which serves Authentic Indian Food"
        />
        <meta
          name="keywords"
          content="Masala of India Cuisine, Disclaimer, Best Indian Restaurant in Northgate, Best Indian Restaurant in Seattle, Best Indian Restaurant in Washington - WA, Best Indian Food, Authentic Indian Food, Indian Lunch Buffet, Lunch Buffet, Tandoori Food, North Indian food in Seattle, Halal Food in Seattle, Halal Food in Northgate, North Indian Food, Indian Food Catering, Catering Services in Seattle, Best Catering Services in Seattle, Indian Restaurants near me, Lunch Buffet Near me, Best Indian Restaurant Near me, Sanjay Sharma, Chef Sanjay Sharma, Indian Ala carte Food, To-go Indian Food, Indian Food Delivery, Order Indian Food Online,
          diner, takeaway, indian takeaway, caterer, lunch restaurant, buffet restaurant, family restaurant, free dining restaurant, north indian restaurant, To-Go & Food Delivery, Online Ordering, Table reservations, Baby Showers, Bridal Showers, Rehearsal Dinner, Retirement, Greenwood, Seattle, WA, USA, Northgate, Seattle, WA, USA, Green Lake, Seattle, WA, USA, Maple Leaf, Seattle, WA, USA, Haller Lake, Seattle, WA, USA, Licton Springs, Seattle, WA, USA, Wedgwood, Seattle, WA 98115, USA, Pinehurst, Seattle, WA 98125, USA, Roosevelt, Seattle, WA 98115, USA, Victory Heights, Seattle, WA, USA, Bitter Lake, Seattle, WA 98133, USA, Morningside, Seattle, WA 98115, USA"
        />

        {/* OG tags */}
        <meta
          property="og:title"
          content="Disclaimer | Masala of India Cusine, Northgate, Seattle - WA"
        />
        <meta
          property="og:description"
          content="Read the Disclaimer of the services provided by Masala of India Cusine, Northgate, Seattle - WA, which serves Authentic Indian Food"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.masalaofindia.com/disclaimer"
        />
        <meta
          property="og:image"
          content="https://www.masalaofindia.com/static/media/inner-banner.e315c31bfa6eb8d37bb1.jpg"
        />
        <meta property="og:site_name" content="masala of india cuisine" />

        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Disclaimer | Masala of India Cusine, Northgate, Seattle - WA"
        />
        <meta
          name="twitter:description"
          content="Read the Disclaimer of the services provided by Masala of India Cusine, Northgate, Seattle - WA, which serves Authentic Indian Food"
        />
        <meta
          name="twitter:image"
          content="https://www.masalaofindia.com/static/media/inner-banner.e315c31bfa6eb8d37bb1.jpg"
        />
        <meta name="twitter:site" content="masala of india cuisine" />
        <link
          rel="canonical"
          href="https://www.masalaofindia.com/disclaimer"></link>
      </Helmet>

      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="page-header-box">
                <h1 class="text-anime">Disclaimer</h1>
                <nav>
                  <ol class="breadcrumb wow fadeInUp" data-wow-delay="0.50s">
                    <li class="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li class="breadcrumb-item active">Disclaimer</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid static-page">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center">Disclaimer</h2>
            <p>
              Masala of India in Seattle provides this website for your
              convenience in ordering and accessing information. While we strive
              to ensure that all menu items, prices, and availability are
              accurate, they may change without prior notice. We are not
              responsible for any issues, losses, or damages that may result
              from using our website or services. Please ensure you verify any
              essential details before placing an order. By using our website,
              you agree to use our services at your own risk.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Disclaimer;
